import { MutationTree } from "vuex";
import { ThemeState, FontFamily, IllustrationEntry } from "../types";

const mutations: MutationTree<ThemeState> = {
  setAccentColor(state, accentColor) {
    state.accentColor = accentColor;
  },
  setSecondaryColor(state, secondaryColor) {
    state.secondaryColor = secondaryColor;
  },
  setGradientStart(state, start: string) {
    state.gradient.start = start;
  },
  setGradientStop(state, stop: string) {
    state.gradient.stop = stop;
  },
  setFontFamily(state, fontFamily: FontFamily) {
    state.fontFamily = fontFamily;
  },
  setWelcomeIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.welcome = illustration;
  },
  setPrepareSelfieIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.prepareSelfie = illustration;
  },
  setChooseCountryIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.chooseCountry = illustration;
  },
  setDriversLicenseFrontIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.driversLicenseFront = illustration;
  },
  setDriversLicenseBackIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.driversLicenseBack = illustration;
  },
  setNationalIdFrontIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.nationalIdFront = illustration;
  },
  setNationalIdBackIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.nationalIdBack = illustration;
  },
  setPassportIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.passport = illustration;
  },
};

export default mutations;
